// extracted by mini-css-extract-plugin
module.exports = {"userTitle":"UserTitle_userTitle__1EPO_","name":"UserTitle_name__3cUOi"};